<!-- Figma "Access Denied" (node 871:987): the logo above a dialog-like card in the middle, the
     copyright strip below it and a triangle artwork in two opposite corners. The artwork is
     exported as 450x450 and 633x450 and scales with the viewport width. -->
<div class="bg-background text-foreground relative grid min-h-screen grid-rows-[minmax(0,1fr)_auto] overflow-hidden">
  <img src="images/access-denied/top-left.svg" alt="" aria-hidden="true" data-cy="access-denied-art-top-left"
    class="pointer-events-none absolute top-0 left-0 aspect-square h-auto w-[clamp(160px,28.125vw,640px)] select-none" />
  <img src="images/access-denied/bottom-right.svg" alt="" aria-hidden="true" data-cy="access-denied-art-bottom-right"
    class="pointer-events-none absolute right-0 bottom-0 aspect-[633/450] h-auto w-[clamp(225px,39.56vw,900px)] select-none" />

  <main class="relative w-[clamp(280px,33.34vw,560px)] max-w-[calc(100%-32px)] self-center justify-self-center">
    <!-- The shared logo is 164x24 for the app bar; the page uses it at 219x32 and always with the
         wordmark, which the app bar variant drops on narrow screens. -->
    <div class="absolute bottom-[calc(100%+8px)] left-1/2 box-content h-8 w-[219px] -translate-x-1/2 p-4">
      <app-logo class="h-6 w-[164px]! origin-top-left scale-[1.3354]" />
    </div>

    <section class="bg-muted flex w-full flex-col items-center gap-4 overflow-clip rounded-[28px] px-4 pt-6"
      aria-labelledby="access-denied-title" data-cy="access-denied">
      <ng-icon name="lucideLockKeyhole" class="text-destructive shrink-0 text-[40px]" aria-hidden="true"
        data-cy="access-denied-icon" />

      <div class="flex w-full flex-col gap-4 px-2 text-center">
        <h1 id="access-denied-title" class="text-2xl leading-8 font-normal">{{ 'accessDenied.title' | translate }}</h1>
        <p class="text-muted-foreground text-sm">{{ 'accessDenied.message' | translate }}</p>
      </div>

      <!-- Both actions are full width, 48px high with a 12px corner radius in the mockup. -->
      <div class="flex w-full flex-col gap-1 py-3">
        <a hlmBtn class="h-12 w-full rounded-xl" [href]="requestAccessUrl" target="_blank" rel="noopener noreferrer"
          data-cy="access-denied-request-access">
          <ng-icon name="lucideExternalLink" data-icon="inline-start" aria-hidden="true" />
          {{ 'accessDenied.requestAccess' | translate }}
        </a>
        <a hlmBtn variant="ghost" class="h-12 w-full rounded-xl" [href]="oktaUrl" data-cy="access-denied-go-to-okta">
          {{ 'accessDenied.goBackToOkta' | translate }}
        </a>
      </div>
    </section>
  </main>

  <app-footer class="relative row-start-2" />
</div>
